import React from "react";

const FixelDataContext = React.createContext();

export default FixelDataContext;
